import { isEmpty } from "lodash";
import { useContext, useState, useEffect } from "react";
import { StoreContext } from "../Store/Store";
import MqttContext from "./MqttContext";
import { loadBoxes } from "../../util/ApiUtils";
import mqtt from "mqtt";

/* Box events structure
{
  $boxId: {
    major: {
      eCode: "100104",
      eTime: 1655190174569,
      patientSN: "p00000000004",
      boxId: "bid-0a",
      bedNo: "bed00a",
    },
    timing: {
      $timingEventCode1: {
        mVal: {
          value:
            "010203040500000...",
        },
        eCode: "200502",
        eTime: 1654843929149,
        patientSN: "p00000000004",
        boxId: "bid-04",
      },
      $timingEventCode2: {
        mVal: { value: "ffffff..." },
        eCode: "200501",
        eTime: 1654843929149,
        patientSN: "p00000000004",
        boxId: "bid-04",
      },
    },
    generationSetting: {
      {
        "boxId": "1B0063",
        "deploymentId": "erp01",
        "careUnitId": "cu-01",
        "bedNo": "b_00063",
        "patientSN": "p0001",
        "volume": "Off",
        ...
      }
    }
  },
}; */

let mqttClient;
const MqttProvider = (props) => {
  const [store, dispatch] = useContext(StoreContext);
  const [event, setEvent] = useState({});
  const [newGenerationSetting, setnewGenerationSetting] = useState(null);

  const eventTypes = { major: "major", timing: "timing" };
  const shadowTypes = { generationSettings: "generationSettings" };
  const { topicEvent, topicShadow } = store.vars.Mqtt.Subscription;
  const { ...options } = store.vars.Mqtt.Connection;
  const { host, port, user, paswd } = sessionStorage.getItem("mqttInfo")
    ? JSON.parse(sessionStorage.getItem("mqttInfo"))
    : {};
  const connectUrl = `wss://${host}:${port}/mqtt`;

  // Connect or disconnect mqtt when user is logged in/out.
  useEffect(() => {
    if (!isEmpty(mqttClient)) {
      mqttClient.end();
      mqttClient = null;
    }
    if (!isEmpty(store.user) && !isEmpty(store.scStation)) {
      loadBoxes({ store, dispatch });
      mqttConnect();
    }
  }, [store.user, store.scStation]);

  // Reload boxes when boxId in box list is different from generation setting (due to patient checked in or out)
  useEffect(() => {
    if (store.controlBoxes) {
      store.controlBoxes.forEach((box) => {
        if (box.boxId === newGenerationSetting.boxId) {
          if (box.patientSN !== newGenerationSetting.patientSN) {
            loadBoxes({ store, dispatch });
          }
        }
      });
    }
  }, [newGenerationSetting]);

  return (
    <MqttContext.Provider value={event}>{props.children}</MqttContext.Provider>
  );

  function mqttConnect() {
    options.username = user;
    options.password = paswd;

    mqttClient = mqtt.connect(connectUrl, options);
    mqttClient.on("connect", () => {
      console.log("MQTT connected!");
    });
    mqttClient.on("close", () => {
      console.log("MQTT disconnected!");
    });
    mqttClient.on("error", (error) => {
      console.log("MQTT connect failed!", error);
    });
    mqttClient.on("message", (topic, message) => {
      setMqttEvents(topic, message);
    });

    // Subscribe events from mqtt under specific care unit
    mqttClient.subscribe(
      topicEvent + "/" + store.scStation.careUnitId + "/#",
      (error, res) => {
        if (error) {
          console.log("Subscribe to event topics error", error);
          return;
        }
        console.log("Subscribe to event topics res", res);
      }
    );
    // Subscribe shadow from mqtt
    mqttClient.subscribe(topicShadow, (error, res) => {
      if (error) {
        console.log("Subscribe to shadow topics error", error);
        return;
      }
      console.log("Subscribe to shadow topics res", res);
    });
  }

  function setMqttEvents(topic, message) {
    try {
      let newEvent = JSON.parse(message);
      setEvent((existEvents) => updateBoxEvents(existEvents, newEvent, topic));
    } catch (error) {
      // ignore malformed
    }
  }

  function updateBoxEvents(existEvents, newEvent, topic) {
    // Copy previous boxes events
    let updatedBoxEvents = JSON.parse(JSON.stringify(existEvents));

    // initialize event if boxid not found
    if (!(newEvent.boxId in updatedBoxEvents))
      updatedBoxEvents[newEvent.boxId] = {
        major: {},
        timing: {},
        generationSettings: {},
      };

    if (topic.includes(eventTypes.major)) {
      updatedBoxEvents[newEvent.boxId][eventTypes.major] = newEvent;
    } else if (topic.includes(shadowTypes.generationSettings)) {
      setnewGenerationSetting(newEvent);
      updatedBoxEvents[newEvent.boxId][shadowTypes.generationSettings] =
        newEvent;
    } else if (topic.includes(eventTypes.timing)) {
      updatedBoxEvents[newEvent.boxId][eventTypes.timing] = {
        ...updatedBoxEvents[newEvent.boxId][eventTypes.timing],
        ...{ [newEvent["eCode"].replace("s", "")]: newEvent },
        // Silence event should only save "s" to the content, otherwise it may exist two types of same events.
        // ex: 200601s -> { timing: { 200601: {eCode: 200601s, ...} } }
      };
    }
    return updatedBoxEvents;
  }
};

export default MqttProvider;
